module.exports = __webpack_public_path__ + "static/img/ARCHER-REID.390d057.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ARCHER-REID.jpg
// module id = 2Zk5
// module chunks = 0